module.exports = __webpack_public_path__ + "static/media/syncui_132.b7c9f755.ico";